import React from 'react'


export default function CarImage({ img }) {
    return (
        <div className='w-full '>
            <div className='absolute w-full h-[30rem] md:h-[50rem] bg-primary-color opacity-30'></div>
            <img src={img} alt="Logo" className='w-full h-[30rem] md:h-[50rem] bg-cover' />
        </div>
    )
}
